/**
 * DevExtreme (esm/renovation/ui/scroll_view/common/consts.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var SCROLL_LINE_HEIGHT = 40;
export var DIRECTION_VERTICAL = "vertical";
export var DIRECTION_HORIZONTAL = "horizontal";
export var DIRECTION_BOTH = "both";
export var SCROLLABLE_SIMULATED_CLASS = "dx-scrollable-simulated";
export var SCROLLABLE_CONTENT_CLASS = "dx-scrollable-content";
export var SCROLLABLE_WRAPPER_CLASS = "dx-scrollable-wrapper";
export var SCROLLABLE_CONTAINER_CLASS = "dx-scrollable-container";
export var SCROLLABLE_DISABLED_CLASS = "dx-scrollable-disabled";
export var SCROLLABLE_SCROLLBAR_SIMULATED = "dx-scrollable-scrollbar-simulated";
export var SCROLLABLE_SCROLLBARS_HIDDEN = "dx-scrollable-scrollbars-hidden";
export var SCROLLABLE_SCROLLBARS_ALWAYSVISIBLE = "dx-scrollable-scrollbars-alwaysvisible";
export var SCROLLABLE_SCROLLBAR_CLASS = "dx-scrollable-scrollbar";
export var SCROLLABLE_SCROLLBAR_ACTIVE_CLASS = "dx-scrollable-scrollbar-active";
export var SCROLLABLE_SCROLL_CLASS = "dx-scrollable-scroll";
export var SCROLLABLE_SCROLL_CONTENT_CLASS = "dx-scrollable-scroll-content";
export var HOVER_ENABLED_STATE = "dx-scrollbar-hoverable";
export var SCROLLVIEW_CONTENT_CLASS = "dx-scrollview-content";
export var SCROLLVIEW_TOP_POCKET_CLASS = "dx-scrollview-top-pocket";
export var SCROLLVIEW_PULLDOWN = "dx-scrollview-pull-down";
export var SCROLLVIEW_PULLDOWN_LOADING_CLASS = "dx-scrollview-pull-down-loading";
export var SCROLLVIEW_PULLDOWN_READY_CLASS = "dx-scrollview-pull-down-ready";
export var SCROLLVIEW_PULLDOWN_IMAGE_CLASS = "dx-scrollview-pull-down-image";
export var SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
export var SCROLLVIEW_PULLDOWN_TEXT_CLASS = "dx-scrollview-pull-down-text";
export var SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS = "dx-scrollview-pull-down-text-visible";
export var PULLDOWN_ICON_CLASS = "dx-icon-pulldown";
export var SCROLLVIEW_BOTTOM_POCKET_CLASS = "dx-scrollview-bottom-pocket";
export var SCROLLVIEW_REACHBOTTOM_CLASS = "dx-scrollview-scrollbottom";
export var SCROLLVIEW_REACHBOTTOM_INDICATOR_CLASS = "dx-scrollview-scrollbottom-indicator";
export var SCROLLVIEW_REACHBOTTOM_TEXT_CLASS = "dx-scrollview-scrollbottom-text";
export var TopPocketState = {
    STATE_RELEASED: 0,
    STATE_READY: 1,
    STATE_REFRESHING: 2,
    STATE_LOADING: 3,
    STATE_TOUCHED: 4,
    STATE_PULLED: 5
};
export var ShowScrollbarMode = {
    HOVER: "onHover",
    ALWAYS: "always",
    NEVER: "never",
    SCROLL: "onScroll"
};
export var KEY_CODES = {
    PAGE_UP: "pageUp",
    PAGE_DOWN: "pageDown",
    END: "end",
    HOME: "home",
    LEFT: "leftArrow",
    UP: "upArrow",
    RIGHT: "rightArrow",
    DOWN: "downArrow"
};
export var VALIDATE_WHEEL_TIMEOUT = 500;
export var HIDE_SCROLLBAR_TIMEOUT = 500;
